/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_TICKET_FETES = gql`
  query GetTicketFetes {
    getTicketFetes {
      feteId
      name
      startsAt
      venue
      imageUrl
      currency
      discountPct
      convenienceFeePct
      maxTicketsPerBox
      tiers {
        tierId
        name
        price
        discountedPrice
        feePerTicket
        available
      }
    }
  }
`;
